// extracted by mini-css-extract-plugin
export default {"controllers":"styles_controllers__iYEX3","copy":"styles_copy__zmhFa","copyNoMargin":"styles_copyNoMargin__89zev","buttoncontainer":"styles_buttoncontainer__iVOfS"};